import axios from "../../../axios-defaults";
import { handleReduxError } from "main/shared/helpers";

import {
  //Get Report
  GET_REMEDIATION_DATA_REQUEST,
  GET_REMEDIATION_DATA_SUCCESS,
  GET_REMEDIATION_DATA_FAIL,

  // Add Row
  ADD_REMEDIATION_ROW_REQUEST,
  ADD_REMEDIATION_ROW_SUCCESS,
  ADD_REMEDIATION_ROW_FAIL,

  // Test List
  GET_TEST_LIST_FAIL,
  GET_TEST_LIST_REQUEST,
  GET_TEST_LIST_SUCCESS,

  // Publish Report
  PUBLISH_REMEDIATION_DATA_FAIL,
  PUBLISH_REMEDIATION_DATA_REQUEST,
  PUBLISH_REMEDIATION_DATA_SUCCESS,

  // Refresh Report
  REFRESH_REMEDIATION_DATA_FAIL,
  REFRESH_REMEDIATION_DATA_REQUEST,
  REFRESH_REMEDIATION_DATA_SUCCESS,

  // Save Report
  SAVE_REMEDIATION_DATA_REQUEST,
  SAVE_REMEDIATION_DATA_SUCCESS,
  SAVE_REMEDIATION_DATA_FAIL,

  // Row Selection
  ROW_SELECTION_REQUEST,
  ROW_SELECTION_SUCCESS,
  ROW_SELECTION_FAIL,

  // Update Header
  UPDATE_HEADER_INFO_REQUEST,
  UPDATE_HEADER_INFO_SUCCESS,
  UPDATE_HEADER_INFO_FAIL,
} from "store/types/remediation_priorities_document/remediationPrioritiesDocumentTypes";
import { compareReportData } from "main/pages/RemidiationPrioritiesDocument/utility/helper";

export const getRemediationDataAction = (inspection_id) => async (dispatch) => {
  try {
    dispatch({ type: GET_REMEDIATION_DATA_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data = {} } = await axios.get(
      `api/v1/remediation-report/${inspection_id}`,
      config
    );

    dispatch({
      type: GET_REMEDIATION_DATA_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    const err = handleReduxError(error);
    dispatch({
      type: GET_REMEDIATION_DATA_FAIL,
      payload: err,
    });
    throw new Error(err);
  }
};

export const getReportDataActionCTA =
  (inspection_id, old_data) => async (dispatch) => {
    try {
      // dispatch({ type: GET_REMEDIATION_DATA_REQUEST });

      const { data = {} } = await axios.get(
        `api/v1/remediation-report/${inspection_id}`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      const isDragged = data?.report_header?.is_dragged;

      const sampleData = compareReportData(
        old_data.remediation_report.data,
        data.remediation_report.data,
        {
          fieldsToCompare: [
            "observation.name",
            "room_name.name",
            "tier",
            "result",
          ],
          sortByField: "observation.name",
          isDragged: isDragged,
          groupByRoom: true,
        }
      );

      const hvacData = compareReportData(old_data.hvac.data, data.hvac.data, {
        fieldsToCompare: ["room_name.name", "tier", "result"],
        isDragged: isDragged,
        groupByRoom: true,
      });

      const ambientData = compareReportData(
        old_data.ambient.data,
        data.ambient.data,
        {
          fieldsToCompare: ["room_name.name", "tier", "result"],
          isDragged: isDragged,
          groupByRoom: true,
        }
      );

      const newData = {
        ...data,
        remediation_report: { ...data.remediation_report, data: sampleData },
        hvac: { ...data.hvac, data: hvacData },
        ambient: { ...data.ambient, data: ambientData },
      };

      dispatch({
        type: GET_REMEDIATION_DATA_SUCCESS,
        payload: newData,
      });

      getTestListAction();

      return newData;
    } catch (error) {
      const err = handleReduxError(error);
      dispatch({
        type: GET_REMEDIATION_DATA_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const getTestListAction = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_TEST_LIST_REQUEST,
    });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data = [] } = await axios.get(`api/v1/tests/?all=true`, config);

    data?.length &&
      data.forEach((test) => {
        test.testId = test.id;
        test.testName = test.name;
      });
    dispatch({
      type: GET_TEST_LIST_SUCCESS,
      payload: data,
    });
    return await data;
  } catch (error) {
    const err = handleReduxError(error);
    dispatch({
      type: GET_TEST_LIST_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

export const updateReportHeader = (data) => async (dispatch, getState) => {
  try {
    dispatch({ type: UPDATE_HEADER_INFO_REQUEST });

    const {
      remediationPrioritiesDocument: { reportData = {} },
    } = getState();

    const cloneReportData = JSON.parse(JSON.stringify(reportData));
    const { report_header = {} } = cloneReportData;

    // Update only the changed header key-value
    report_header[data.key] = data.value;
    dispatch({
      type: UPDATE_HEADER_INFO_SUCCESS,
      payload: cloneReportData,
    });
  } catch (error) {
    const err = handleReduxError(error);
    dispatch({
      type: UPDATE_HEADER_INFO_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

export const updateHeaderInfoDrag =
  (data, remediation_report, table) => async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_HEADER_INFO_REQUEST,
      });

      const {
        remediationPrioritiesDocument: { reportData = {} },
      } = getState();
      const cloneReportData = JSON.parse(JSON.stringify(reportData));
      const { report_header = {} } = cloneReportData;
      report_header[data.key] = data.value;

      // Dynamically update the correct table's data
      if (remediation_report?.length && table) {
        if (!cloneReportData[table]) {
          cloneReportData[table] = { data: [] };
        }
        cloneReportData[table].data = remediation_report;
      }

      dispatch({
        type: UPDATE_HEADER_INFO_SUCCESS,
        payload: cloneReportData,
      });
    } catch (error) {
      const err = handleReduxError(error);
      dispatch({
        type: UPDATE_HEADER_INFO_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const handleRowSelectionAction =
  (row, tableKey) => async (dispatch, getState) => {
    try {
      dispatch({ type: ROW_SELECTION_REQUEST });

      const {
        remediationPrioritiesDocument: { reportData = {} },
      } = getState();

      const cloneReportData = JSON.parse(JSON.stringify(reportData));
      const targetTable = cloneReportData[tableKey];

      if (targetTable?.data?.length) {
        targetTable.data.forEach((r) => {
          if (r.id === row.id) {
            row.status = !row.status;
          }
        });
      }

      dispatch({
        type: ROW_SELECTION_SUCCESS,
        payload: cloneReportData,
      });
    } catch (error) {
      const err = handleReduxError(error);
      dispatch({
        type: ROW_SELECTION_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const handleAllSelectionAction =
  (row, tableKey) => async (dispatch, getState) => {
    try {
      dispatch({ type: ROW_SELECTION_REQUEST });

      const {
        remediationPrioritiesDocument: { reportData = {} },
      } = getState();

      const cloneReportData = JSON.parse(JSON.stringify(reportData));
      const targetTable = cloneReportData[tableKey];

      if (targetTable?.data?.length) {
        targetTable.data.forEach((r) => {
          row.status = !row.status;
        });
      }

      dispatch({
        type: ROW_SELECTION_SUCCESS,
        payload: cloneReportData,
      });
    } catch (error) {
      const err = handleReduxError(error);
      dispatch({
        type: ROW_SELECTION_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const handleRowStatusAction =
  (row, tableKey) => async (dispatch, getState) => {
    try {
      dispatch({ type: ROW_SELECTION_REQUEST });

      const {
        remediationPrioritiesDocument: { reportData = {} },
      } = getState();

      const cloneReportData = JSON.parse(JSON.stringify(reportData));
      const targetTable = cloneReportData[tableKey];

      if (targetTable?.data?.length) {
        targetTable.data.forEach((r) => {
          if (r.id === row.id) {
            r.status = !r.status;
          }
        });
      }

      dispatch({
        type: ROW_SELECTION_SUCCESS,
        payload: cloneReportData,
      });
    } catch (error) {
      const err = handleReduxError(error);
      dispatch({
        type: ROW_SELECTION_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const handleAllRowDeleteAction =
  (setHasUnapprovedItems) => async (dispatch, getState) => {
    try {
      dispatch({ type: ROW_SELECTION_REQUEST });

      const {
        remediationPrioritiesDocument: { reportData = {} },
      } = getState();

      const cloneReportData = JSON.parse(JSON.stringify(reportData));

      const tableKeys = ["remediation_report", "hvac", "ambient"];
      tableKeys.forEach((key) => {
        const targetTable = cloneReportData[key];
        if (targetTable?.data?.length) {
          targetTable.data = targetTable.data.filter((r) => r.status !== false);
        }
      });

      dispatch({
        type: ROW_SELECTION_SUCCESS,
        payload: cloneReportData,
      });
      setHasUnapprovedItems(false);
    } catch (error) {
      const err = handleReduxError(error);
      dispatch({
        type: ROW_SELECTION_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const handleAddRowAction =
  (tableKey, setNewRowsAddedData) => async (dispatch, getState) => {
    try {
      dispatch({ type: ADD_REMEDIATION_ROW_REQUEST });

      const {
        remediationPrioritiesDocument: { reportData = {} },
      } = getState();

      const cloneReportData = JSON.parse(JSON.stringify(reportData));
      const currentTime = new Date().toISOString();

      const generateUniqueId = () => {
        const timestamp = Date.now();
        const randomPart = Math.floor(Math.random() * (1_000_000 - 10) + 10);
        return Number(`${timestamp}${randomPart}`);
      };

      const rowId = generateUniqueId();
      const observationId = generateUniqueId();
      const roomId = generateUniqueId();

      const defaultRowTemplates = {
        remediation_report: {
          observation_id: observationId,
          observation_tests_id: null,
          status: false,
          observation: {
            name: "",
            created_at: currentTime,
            edit_col: true,
          },
          room_name: {
            id: roomId,
            name: "",
            room_type_name: "",
            edit_col: true,
          },
          test: {
            id: null,
            name: "",
            edit_col: true,
          },
          test_sample: {
            id: null,
            test_id: null,
            name: "",
            cost: "",
            edit_col: true,
          },
          sample_info: [
            { id: "1", name: "Sample Location", value: "", edit_col: true },
            { id: "2", name: "Lab Code", value: "", edit_col: true },
          ],
          sample_reason: { id: "", name: "None" },
          client_approved: false,
          row_number: null,
          sample_note: "",
          edit_row: true,
          result: null,
          tier: null,
        },
        hvac: {
          observation_id: observationId,
          observation_tests_id: null,
          status: false,
          observation: {
            name: "",
            created_at: currentTime,
          },
          room_name: {
            id: roomId,
            name: "",
            room_type_name: "",
          },
          test: {
            id: null,
            name: "",
          },
          test_sample: {
            id: null,
            test_id: null,
            name: "",
            cost: "",
          },
          sample_info: [
            { id: "1", name: "Sample Location", value: "" },
            { id: "2", name: "Lab Code", value: "" },
          ],
          sample_reason: { id: "", name: "None" },
          client_approved: false,
          result: null,
          tier: null,
        },
        ambient: {
          observation_id: observationId,
          observation_tests_id: null,
          status: false,
          observation: {
            name: "",
            created_at: currentTime,
          },
          room_name: {
            id: roomId,
            name: "",
            room_type_name: "",
          },
          test: {
            id: null,
            name: "",
          },
          test_sample: {
            id: null,
            test_id: null,
            name: "",
            cost: "",
          },
          sample_info: [
            { id: "1", name: "Sample Location", value: "" },
            { id: "2", name: "Lab Code", value: "" },
          ],
          sample_reason: { id: "", name: "None" },
          client_approved: false,
          result: null,
          tier: null,
        },
      };

      const template = defaultRowTemplates[tableKey];

      if (!template) {
        throw new Error(`Unknown table key: ${tableKey}`);
      }

      const defaultRow = {
        id: rowId,
        ...template,
      };

      if (!cloneReportData[tableKey]) {
        cloneReportData[tableKey] = { data: [] };
      }

      cloneReportData[tableKey].data.push(defaultRow);

      dispatch({
        type: ADD_REMEDIATION_ROW_SUCCESS,
        payload: cloneReportData,
      });

      setNewRowsAddedData((prev) => ({
        ...prev,
        [tableKey]: [...(prev[tableKey] || []), rowId],
      }));
    } catch (error) {
      const err = handleReduxError(error);
      dispatch({
        type: ADD_REMEDIATION_ROW_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const handleRowDeleteAction =
  (row, tableKey, setNewRowsAddedData) => async (dispatch, getState) => {
    try {
      dispatch({ type: ROW_SELECTION_REQUEST });

      const {
        remediationPrioritiesDocument: { reportData = {} },
      } = getState();

      const cloneReportData = JSON.parse(JSON.stringify(reportData));
      const targetTable = cloneReportData[tableKey];

      if (targetTable?.data?.length) {
        targetTable.data = targetTable.data.filter((r) => r.id !== row.id);
      }

      dispatch({
        type: ROW_SELECTION_SUCCESS,
        payload: cloneReportData,
      });

      setNewRowsAddedData((prev) => ({
        ...prev,
        [tableKey]: prev[tableKey].filter((id) => id !== row.id),
      }));
    } catch (error) {
      const err = handleReduxError(error);
      dispatch({
        type: ROW_SELECTION_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const saveRemediationDataAction =
  (inspection_id) => async (dispatch, getState) => {
    try {
      dispatch({
        type: SAVE_REMEDIATION_DATA_REQUEST,
      });
      const {
        remediationPrioritiesDocument: { reportData },
      } = getState();
      const cloneReportData = JSON.parse(JSON.stringify(reportData));
      const body = {
        data: JSON.stringify(reportData),
      };
      const { data: responseData = {} } = await axios.post(
        `api/v1/remediation-report/${inspection_id}/save`,
        body
      );
      dispatch({
        type: SAVE_REMEDIATION_DATA_SUCCESS,
        payload: cloneReportData,
      });
      return await responseData;
    } catch (error) {
      const err = handleReduxError(error);
      dispatch({
        type: SAVE_REMEDIATION_DATA_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const refreshRemediationtDataAction =
  (inspection_id) => async (dispatch) => {
    try {
      dispatch({
        type: REFRESH_REMEDIATION_DATA_REQUEST,
      });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data = {} } = await axios.get(
        `api/v1/remediation-report/${inspection_id}?reset=true`,
        config
      );

      dispatch({
        type: REFRESH_REMEDIATION_DATA_SUCCESS,
      });
      dispatch({
        type: GET_REMEDIATION_DATA_SUCCESS,
        payload: data,
      });
    } catch (error) {
      const err = handleReduxError(error);
      dispatch({
        type: REFRESH_REMEDIATION_DATA_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const publishRemediationDataAction =
  (inspection_id, type) => async (dispatch, getState) => {
    try {
      dispatch({
        type: PUBLISH_REMEDIATION_DATA_REQUEST,
      });
      const {
        remediationPrioritiesDocument: { reportData },
      } = getState();
      const body = {
        data: JSON.stringify(reportData),
      };
      const { data: responseData = {} } = await axios.post(
        `api/v1/remediation-report/${inspection_id}/publish?type=${type}`,
        body
      );
      dispatch({
        type: PUBLISH_REMEDIATION_DATA_SUCCESS,
        payload: responseData,
      });

      return await responseData;
    } catch (error) {
      const err = handleReduxError(error);
      dispatch({
        type: PUBLISH_REMEDIATION_DATA_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const fetchLabResultsAction =
  (inspection_id, reportDataOverride = null) =>
  async (dispatch, getState) => {
    try {
      const reportData =
        reportDataOverride ||
        getState().remediationPrioritiesDocument?.reportData ||
        {};

      if (!reportData?.remediation_report?.data?.length) {
        return;
      }

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const response = await axios.get(
        `api/v1/inspection/${inspection_id}/tests-lab-results`,
        config
      );

      // Extract data and outside_room from response
      const labResults = Array.isArray(response.data?.data)
        ? response.data.data
        : Array.isArray(response.data)
          ? response.data
          : [];

      const outsideRoom = response.data?.outside_room || null;

      if (!Array.isArray(labResults)) {
        console.warn("Lab results is not an array:", labResults);
        return;
      }

      const cloneReportData = JSON.parse(JSON.stringify(reportData));

      // Save labResults and outsideRoom to reportData
      cloneReportData.labResults = labResults;
      cloneReportData.outsideRoom = outsideRoom;

      // Merge result_data into remediation_report.data
      if (cloneReportData.remediation_report?.data?.length) {
        cloneReportData.remediation_report.data.forEach((item) => {
          const matchingLabResult = labResults.find(
            (labResult) => labResult.id === item.id
          );
          if (matchingLabResult?.result_data) {
            item.result_data = matchingLabResult;
          }
        });
      }

      dispatch({
        type: GET_REMEDIATION_DATA_SUCCESS,
        payload: cloneReportData,
      });
    } catch (error) {
      console.error("Error fetching lab results:", error);
      // Don't throw error, just log it - lab results are optional
    }
  };
